const numberFormatter = new Intl.NumberFormat('tr-TR', {
    maximumFractionDigits: 0,
});

const percentFormatter = new Intl.NumberFormat('tr-TR', {
    maximumFractionDigits: 0,
});

export const formatNumber = (value: number) => numberFormatter.format(value);

export const formatSalary = (value: number) =>
    `${numberFormatter.format(Math.round(value))} TL`;

export const formatCompactSalary = (value: number) => {
    if (Math.abs(value) >= 1_000_000) {
        return `${new Intl.NumberFormat('tr-TR', {
            maximumFractionDigits: 1,
        }).format(value / 1_000_000)} mn TL`;
    }

    if (Math.abs(value) >= 1_000) {
        return `${numberFormatter.format(value / 1_000)} bin`;
    }

    return numberFormatter.format(value);
};

export const formatSample = (value: number) =>
    `${numberFormatter.format(value)} katılımcı`;

export const formatPercent = (value: number) =>
    `%${percentFormatter.format(Math.abs(value))}`;
